import { useWSHeatmapClickedElements } from './useWSHeatmapClickedElements';
import { useWSHeatmapAnalytics } from './useWSHeatmapAnalytics';
import { useWSHeatmapClicks } from './useWSHeatmapClicks';

// Query key prefixes for each data type
export const HEATMAP_QUERY_KEYS = {
  clicks: 'HeatmapClicks',
  clickedElements: 'ClickedElements',
  analytics: 'HeatmapAnalytics',
  scroll: 'HeatmapScroll',
} as const;

export const useWSFetchHeatmapData = () => {
  useWSHeatmapClicks();
  useWSHeatmapClickedElements();
  useWSHeatmapAnalytics();
};
